const decodeJwtPayload = (token: string): Record<string, unknown> | null => {
  try {
    const payload = token.split('.')[1]
    if (!payload) return null
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    return JSON.parse(atob(padded))
  } catch {
    return null
  }
}

export const getJwtExpiryMs = (token: string): number | null => {
  const json = decodeJwtPayload(token)
  return typeof json?.exp === 'number' ? json.exp * 1000 : null
}

export interface IJwtUser {
  userId?: number
  firstName?: string
  lastName?: string
}

/** Who the token was issued to: userId, firstName and lastName are all claims. */
export const getJwtUser = (token: string): IJwtUser => {
  const claims = decodeJwtPayload(token)
  return {
    userId: typeof claims?.userId === 'number' ? claims.userId : undefined,
    firstName: typeof claims?.firstName === 'string' ? claims.firstName : undefined,
    lastName: typeof claims?.lastName === 'string' ? claims.lastName : undefined,
  }
}
